import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { Link } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/supply-chain/")({
  component: SupplyChain,
});

function SupplyChain() {
  return (
    <>
      <PageHeader title="Supply Chain" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Supply Chain"
          description="Soon, you'll be able to link your cattle with established supply chains, making it easier for buyers to find you and helping you optimize your sales strategy."
          Icon={Link}
        />
      </main>
    </>
  );
}
